"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _tableContext = require("./Context/tableContext");
var enhance = function enhance(Component) {
  return function (props) {
    var data = props.data,
      columns = props.columns,
      children = props.children,
      objectAllData = props.objectAllData,
      indexList = props.indexList,
      expandable = props.expandable;
    return /*#__PURE__*/_react.default.createElement(_tableContext.TableProvider, {
      data: data,
      columns: columns,
      children: children,
      objectAllData: objectAllData,
      expandable: expandable,
      indexList: indexList
    }, /*#__PURE__*/_react.default.createElement(Component, props));
  };
};
var _default = exports.default = enhance;